import { ArrayValues, ValueOf } from 'type-fest';

const dateSiteOptions = [
  { id: 'sites', title: 'Sites' },
  { id: 'date', title: 'Date' },
] as const;

export type DateSiteOptions = ValueOf<
  ArrayValues<typeof dateSiteOptions>,
  'id'
>;

export default dateSiteOptions;
